module.exports = "/packs/media/images/brands/wealthfront-b18f1fd278335ce6486577575e0ba121.png";